// extracted by mini-css-extract-plugin
module.exports = {"tarjeta":"card_tarjeta__3DNAX"};